import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import './legal.css'

const Legal = (props) => {
  return (
    <div className="legal-container1">
      <Helmet>
        <title>Legal - Boton</title>
        <meta
          name="description"
          content="Reemplaza tu software contable tradicional con uno que usa AI para ahorrar tiempo, mejorar la precisión y generar información financiera valiosa."
        />
        <meta property="og:title" content="Legal - Boton" />
        <meta
          property="og:description"
          content="Contabilidad Autónoma. Las obligaciones y números de tu compañía al día. Todos los días."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/7e6dbf1e-be7a-4923-b883-585e35cd49f7/a0ccc604-ae9c-4ffb-af09-ccf2aa7f1016?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <header className="legal-header">
        <div id="mobile-menu" className="legal-mobile-navigation">
          <img
            alt="pastedImage"
            src="/boton_logo/boton%20black%20wide-1500h.png"
            className="legal-logo1"
          />
          <div className="legal-links1">
            <a
              href="https://botonapp.com/login"
              target="_blank"
              rel="noreferrer noopener"
              className="legal-login"
            >
              Login
            </a>
          </div>
          <div id="close-mobile-menu" className="legal-close-mobile-menu">
            <svg viewBox="0 0 804.5714285714286 1024" className="legal-icon1">
              <path d="M741.714 755.429c0 14.286-5.714 28.571-16 38.857l-77.714 77.714c-10.286 10.286-24.571 16-38.857 16s-28.571-5.714-38.857-16l-168-168-168 168c-10.286 10.286-24.571 16-38.857 16s-28.571-5.714-38.857-16l-77.714-77.714c-10.286-10.286-16-24.571-16-38.857s5.714-28.571 16-38.857l168-168-168-168c-10.286-10.286-16-24.571-16-38.857s5.714-28.571 16-38.857l77.714-77.714c10.286-10.286 24.571-16 38.857-16s28.571 5.714 38.857 16l168 168 168-168c10.286-10.286 24.571-16 38.857-16s28.571 5.714 38.857 16l77.714 77.714c10.286 10.286 16 24.571 16 38.857s-5.714 28.571-16 38.857l-168 168 168 168c10.286 10.286 16 24.571 16 38.857z"></path>
            </svg>
          </div>
        </div>
        <div className="legal-desktop-navigation">
          <nav className="legal-centered">
            <div className="legal-left">
              <img
                alt="pastedImage"
                src="/boton_logo/boton-200h.png"
                className="legal-logo2"
              />
              <div className="legal-links2">
                <a href="#howitworks" className="legal-link1 Link">
                  Cómo funciona
                </a>
                <a href="#planes" className="legal-link2 Link">
                  <span>Planes</span>
                  <br></br>
                </a>
              </div>
            </div>
            <div className="legal-right">
              <a
                href="https://botonapp.com/login"
                target="_blank"
                rel="noreferrer noopener"
                className="legal-sign-in Link"
              >
                Log in
              </a>
              <a
                href="https://botonapp.com/botonboarding"
                target="_blank"
                rel="noreferrer noopener"
                className="legal-link3"
              >
                <div className="legal-get-started">
                  <span className="legal-text3">Empezar gratis</span>
                </div>
              </a>
              <div id="open-mobile-menu" className="legal-burger-menu">
                <img
                  alt="pastedImage"
                  src="/pastedimage-yxbd.svg"
                  className="legal-mobile-menu-button"
                />
              </div>
            </div>
          </nav>
        </div>
        <div>
          <div className="legal-container3">
            <Script
              html={`<script defer>
/*
Mobile menu - Code Embed
*/

// Mobile menu
const mobileMenu = document.querySelector("#mobile-menu")

// Buttons
const closeButton = document.querySelector("#close-mobile-menu")
const openButton = document.querySelector("#open-mobile-menu")

// On openButton click, set the mobileMenu position left to -100vw
openButton.addEventListener("click", function() {
    mobileMenu.style.transform = "translateX(0%)"
})

// On closeButton click, set the mobileMenu position to 0vw
closeButton.addEventListener("click", function() {
    mobileMenu.style.transform = "translateX(100%)"
})
</script>`}
            ></Script>
          </div>
        </div>
      </header>
      <div className="legal-container4">
        <div className="legal-container5">
          <Script
            html={`
      <h3>Términos y Condiciones de BOTON (Helio UAV S.A.)</h3>

      <h4>1. Tratamiento de datos personales</h4>
      <p>
        BOTON, operado por Helio UAV S.A., recopila y trata los datos personales
        del Cliente de acuerdo con la Ley Nº 81 de 2019 de Protección de Datos
        Personales de Panamá. Toda información proporcionada por el Cliente será
        utilizada únicamente con fines determinados, legítimos y necesarios para
        la prestación de los servicios de software de contabilidad y
        cumplimiento empresarial ofrecidos por BOTON. Esto incluye, entre otras
        actividades, la automatización de procesos contables, la gestión de
        obligaciones fiscales y regulatorias, y la interconexión con sistemas
        externos autorizados por el Cliente. En ningún caso BOTON tratará los
        datos personales del Cliente para fines incompatibles con aquellos aquí
        descritos sin obtener un consentimiento adicional del Cliente.
      </p>

      <h4>2. Obtención del consentimiento informado</h4>
      <p>
        El Cliente otorga su consentimiento libre, previo, informado e
        inequívoco para el tratamiento de sus datos personales al aceptar estos
        Términos y Condiciones durante el proceso de registro (onboarding) en la
        plataforma BOTON.
      </p>
      <p>
        Dicha aceptación se realiza marcando la casilla de verificación
        (checkbox) dispuesta a tal efecto, indicando así que el Cliente ha
        leído, comprendido y aceptado las presentes condiciones. El
        consentimiento del Cliente permite a BOTON recolectar, almacenar, usar
        y, en su caso, compartir con terceros autorizados los datos personales
        del Cliente según lo establecido en este documento. El Cliente podrá
        revocar su consentimiento en cualquier momento; no obstante, entiende
        que la revocación del consentimiento podría implicar la imposibilidad de
        que BOTON continúe brindando sus servicios, lo que dará lugar a la
        terminación de la relación contractual conforme a la sección 13.
      </p>

      <h4>3. Almacenamiento de datos y medidas de seguridad</h4>
      <p>
        BOTON almacena la información del Cliente en sistemas y bases de datos
        seguras, utilizando proveedores de tecnología que cumplen con estándares
        internacionales de seguridad de la información. Se implementan medidas
        técnicas y organizativas apropiadas para proteger los datos personales
        contra acceso no autorizado, pérdida, alteración, divulgación o
        destrucción indebida.
      </p>
      <p>
        Entre estas medidas se incluye el cifrado de datos sensibles (como
        contraseñas y credenciales) tanto en transmisión como en almacenamiento,
        controles de acceso restringido a personal autorizado de BOTON,
        monitoreo de la seguridad de la plataforma, y pruebas periódicas para
        detectar vulnerabilidades. Además, BOTON se compromete a informar al
        Cliente lo antes posible en caso de detectar alguna violación de
        seguridad que comprometa sus datos personales, y a tomar las acciones
        correctivas necesarias, en cumplimiento de la Ley 81 de 2019.
      </p>

      <h4>4. Políticas de acceso y confidencialidad</h4>
      <p>
        La información del Cliente es tratada con estricta confidencialidad.
        Solo tendrán acceso a los datos personales aquellos empleados,
        contratistas o colaboradores de BOTON que necesiten conocer dicha
        información para llevar a cabo las finalidades descritas (por ejemplo,
        personal técnico de soporte o desarrolladores a cargo del mantenimiento
        del sistema, bajo los debidos protocolos). Estas personas están sujetas
        a obligaciones contractuales de confidencialidad y protección de datos,
        las cuales continúan incluso después de finalizada su relación laboral o
        contractual con BOTON. BOTON no divulgará información personal del
        Cliente a terceros no autorizados, salvo obligación legal o
        consentimiento expreso del Cliente.
      </p>
      <p>
        Por su parte, el Cliente es responsable de mantener la confidencialidad
        de sus propias credenciales de acceso a BOTON (nombre de usuario y
        contraseña de la plataforma) y de no compartirlas con personas no
        autorizadas, asumiendo la responsabilidad por cualquier actividad
        realizada en su cuenta. En caso de sospecha de uso no autorizado de la
        cuenta o de la información, el Cliente deberá notificar a BOTON de
        inmediato para que se tomen las medidas de seguridad pertinentes.
      </p>

      <h4>5. Derechos y obligaciones de las partes</h4>
      <p>
        Derechos del Cliente: El Cliente, como titular de sus datos personales,
        goza de todos los derechos que le otorga la ley panameña de protección
        de datos. Esto incluye, entre otros:
      </p>
      <ul>
        <li>
          Derecho de información: conocer qué información suya está siendo
          recopilada y cómo es tratada por BOTON.
        </li>
        <li>
          Derecho de acceso: acceder a sus datos personales en posesión de
          BOTON.
        </li>
        <li>
          Derecho de rectificación: solicitar la corrección o actualización de
          sus datos cuando sean inexactos o estén desactualizados.
        </li>
        <li>
          Derecho de cancelación (eliminación): pedir la cancelación o
          eliminación de sus datos cuando considere que no son necesarios para
          las finalidades aquí descritas o decida terminar la relación con
          BOTON.
        </li>
        <li>
          Derecho de oposición: oponerse al tratamiento de sus datos para fines
          específicos (por ejemplo, para fines distintos a los necesarios en el
          servicio; en caso de que la oposición recaiga sobre un tratamiento
          esencial para la prestación del servicio, BOTON le informará sobre las
          consecuencias de ejercer este derecho).
        </li>
      </ul>
      <p>
        El Cliente podrá ejercer estos derechos (conocidos como derechos ARCO)
        en cualquier momento, enviando una solicitud a través de los canales de
        atención dispuestos por BOTON. BOTON atenderá dichas solicitudes en los
        términos establecidos por la ley.
      </p>
      <p>Obligaciones del Cliente. El Cliente se compromete a:</p>
      <ul>
        <li>
          Proporcionar información veraz, exacta y actualizada al registrarse y
          durante el uso de los servicios de BOTON, tanto en lo relativo a sus
          datos personales como a los datos de su empresa necesarios para fines
          contables y de cumplimiento.
        </li>
        <li>
          Mantener actualizada dicha información, notificando a BOTON de
          cualquier cambio relevante en sus datos o en la información de su
          empresa.
        </li>
        <li>
          Utilizar la plataforma BOTON y sus servicios solo con fines lícitos y
          de acuerdo con lo establecido en estos Términos y Condiciones.
        </li>
        <li>
          No compartir ni ceder sus credenciales de acceso a personas no
          autorizadas (salvo en los casos de usuarios adicionales contemplados
          en la sección 8), ni permitir accesos no autorizados a la plataforma.
          El Cliente debe velar porque los usuarios adicionales que incorpore a
          su cuenta cumplan con las presentes condiciones y las normas de
          confidencialidad aquí establecidas.
        </li>
        <li>
          Pagar puntualmente las tarifas o cuotas del servicio en las fechas
          pactadas, y cumplir con cualesquiera otras obligaciones de pago o
          contractuales establecidas con BOTON.
        </li>
      </ul>
      <p>Obligaciones de BOTON. BOTON se compromete a:</p>
      <ul>
        <li>
          Tratar los datos del Cliente de manera lícita, leal y transparente,
          cumpliendo con la Ley 81 de 2019 y demás normativas aplicables.
        </li>
        <li>
          Limitar el uso de los datos exclusivamente a las finalidades
          informadas en estos Términos y Condiciones (prestación de servicios
          contables y de cumplimiento) y a aquellos propósitos compatibles o
          legalmente permitidos.
        </li>
        <li>
          Mantener los datos exactos y actualizados, corrigiendo o actualizando
          la información cuando el Cliente lo solicite o comunique cambios
          relevantes.
        </li>
        <li>
          Implementar las medidas de seguridad y confidencialidad adecuadas para
          proteger la información del Cliente, tal como se detalla en la sección
          3.
        </li>
        <li>
          Respetar y facilitar el ejercicio de los derechos del Cliente en
          materia de protección de datos (acceso, rectificación, cancelación,
          oposición), respondiendo a sus solicitudes en los plazos y condiciones
          que fija la ley.
        </li>
        <li>
          No ceder ni transferir los datos personales del Cliente a terceros
          salvo (i) cuando sea necesario para la prestación del servicio a
          través de proveedores contratados que actúen bajo las instrucciones de
          BOTON y con las debidas garantías de confidencialidad, o (ii) por
          requerimiento legal de autoridades competentes, según lo permitido por
          la normativa vigente.
        </li>
        <li>
          Informar al Cliente sobre cambios materiales en las presentes
          condiciones o en las políticas de privacidad que afecten el
          tratamiento de sus datos, así como sobre cualquier incidencia
          relevante relacionada con la seguridad de su información.
        </li>
      </ul>

      <h4>6. Información manejada por BOTON</h4>
      <p>
        Para brindar sus servicios, BOTON podrá recopilar y manejar diversas
        categorías de información del Cliente, tanto personal como relacionada
        con su empresa. Entre los datos que BOTON manejará se incluyen, de
        manera enunciativa pero no limitativa:
      </p>
      <ul>
        <li>
          Datos personales de identificación y contacto: nombre completo, cédula
          o número de identificación personal o de la empresa, correo
          electrónico, dirección física, número de teléfono y demás datos de
          contacto necesarios.
        </li>
        <li>
          Información financiera y contable: registros contables, facturas,
          recibos, comprobantes de pago, declaraciones de impuestos, estados
          financieros, estados de cuenta bancarios, información de planilla
          (nómina) y cualquier otro dato financiero que el Cliente provea o que
          se genere a través de la plataforma BOTON para cumplir con sus
          obligaciones contables y fiscales.
        </li>
        <li>
          Credenciales de acceso a sistemas externos: información de inicio de
          sesión (nombre de usuario, contraseña, tokens de autenticación u otros
          medios de acceso) que el Cliente decida proporcionar a BOTON para la
          conexión con plataformas de terceros necesarias para la gestión
          contable y de cumplimiento. Esto puede incluir, por ejemplo, las
          credenciales de acceso a la Dirección General de Ingresos (DGI) para
          gestiones tributarias, a plataformas municipales para trámites
          locales, al Sistema de Ingresos y Prestaciones Económicas (SIPE) de la
          Caja de Seguro Social, a la banca en línea de Banco General u otras
          instituciones financieras, y a cualquier otro sistema relevante que el
          Cliente integre con BOTON.
        </li>
        <li>
          Datos de terceros relacionados: en la medida en que sea necesario para
          la contabilidad, el Cliente podría proporcionar datos de terceros (por
          ejemplo, información de sus proveedores, clientes o empleados para
          facturación o pago de planilla). El Cliente afirma que cuenta con la
          autorización para compartir dichos datos con BOTON y que ha informado
          a esos terceros cuando la ley así lo requiera.
        </li>
      </ul>
      <p>
        Toda esta información será manejada de conformidad con las presentes
        condiciones y con la legislación de protección de datos aplicable. BOTON
        tratará esta información como confidencial y aplicará las medidas de
        seguridad mencionadas en la sección 3 para protegerla. En ningún caso
        BOTON solicitará o accederá a información que no sea pertinente para las
        finalidades del servicio.
      </p>

      <h4>7. Uso exclusivo de los datos</h4>
      <p>
        Los datos proporcionados por el Cliente a BOTON serán utilizados única y
        exclusivamente para la prestación de los servicios contratados, es
        decir, para asistir al Cliente en sus procesos contables, financieros y
        de cumplimiento empresarial. BOTON no utilizará los datos personales ni
        la información financiera del Cliente para propósitos distintos a los
        aquí establecidos sin contar con la autorización expresa del Cliente.
      </p>
      <p>
        En particular, BOTON se abstendrá de emplear los datos del Cliente con
        fines publicitarios, de mercadeo o prospección comercial ajenos al
        servicio de software de contabilidad, a menos que el Cliente otorgue un
        consentimiento adicional y específico para ello.
      </p>
      <p>
        Asimismo, BOTON no compartirá la información del Cliente con terceros,
        salvo que sea indispensable para cumplir con las finalidades del
        servicio (por ejemplo, comunicación con proveedores tecnológicos o
        autoridades competentes, según lo descrito en estas condiciones) o por
        exigencia de una ley o autoridad competente. Cualquier tratamiento de
        datos por parte de BOTON se hará en apego al principio de finalidad
        establecido en la Ley 81 de 2019, garantizando que los datos no sean
        tratados de manera incompatible con los propósitos originales para los
        cuales fueron recopilados.
      </p>

      <h4>8. Acceso de terceros</h4>
      <p>
        La plataforma BOTON permite al Cliente invitar o autorizar a terceros
        para que accedan a su cuenta, tales como colaboradores internos de su
        empresa (ej. socios, empleados) o profesionales externos que le brinden
        servicios (por ejemplo, contadores o auditores). El Cliente podrá
        otorgar a estos usuarios adicionales distintos niveles de acceso
        (parcial o total) a la información contenida en la plataforma, de
        acuerdo con las funcionalidades disponibles.
      </p>
      <p>
        Es responsabilidad del Cliente seleccionar cuidadosamente a los terceros
        a los que concede acceso y definir los permisos apropiados para cada
        uno. Los usuarios terceros autorizados por el Cliente deberán acceder a
        la información únicamente para los fines ligados a la empresa del
        Cliente y bajo las mismas obligaciones de confidencialidad y protección
        de datos establecidas en estos Términos y Condiciones.
      </p>
      <p>
        El Cliente reconoce que cualquier acción realizada por los usuarios
        autorizados en la plataforma se entenderá como realizada en su nombre y
        representación. Por tanto, el Cliente asume la responsabilidad por el
        uso que dichos terceros hagan de la información a la que se les ha dado
        acceso. BOTON no será responsable por las actuaciones o negligencias de
        los usuarios adicionales que el Cliente habilite, más allá de proveer el
        acceso a la plataforma conforme a las instrucciones del Cliente.
      </p>
      <p>
        No obstante, si BOTON detecta un uso indebido de la información por
        parte de un usuario autorizado, podrá (previa notificación al Cliente
        cuando sea posible) revocar o limitar el acceso de dicho usuario para
        proteger los datos.
      </p>
      <p>
        El Cliente podrá en cualquier momento revocar o modificar los accesos
        otorgados a terceros a través de las herramientas de administración de
        usuarios en la plataforma o solicitándolo a BOTON.
      </p>

      <h4>9. Uso de inteligencia artificial</h4>
      <p>
        BOTON utiliza tecnologías de inteligencia artificial (IA) y aprendizaje
        automático con el objetivo de automatizar y optimizar diversos procesos
        contables y administrativos en beneficio del Cliente. Por ejemplo, la IA
        podría emplearse para clasificar transacciones, reconocer información en
        documentos (mediante reconocimiento óptico de caracteres u otras
        técnicas), generar reportes financieros preliminares o identificar
        posibles incumplimientos u oportunidades de mejora en la gestión
        contable. El Cliente acepta y entiende que ciertos resultados,
        recomendaciones o acciones dentro de la plataforma pueden ser generados
        de manera automatizada por estos sistemas de IA.
      </p>
      <p>
        En algunos casos, para brindar estas funcionalidades de inteligencia
        artificial, BOTON podrá comunicarse con proveedores externos de
        servicios de procesamiento de datos o herramientas de IA. Esto significa
        que algunos datos del Cliente podrían ser transmitidos de forma segura a
        dichos proveedores tecnológicos (por ejemplo, servicios en la nube que
        realizan análisis de datos o algoritmos de aprendizaje automático) con
        el único fin de ser procesados según las instrucciones de BOTON y
        devolver un resultado útil para el Cliente. BOTON se asegurará de que
        cualquier proveedor de este tipo con el que colabore mantenga estándares
        adecuados de seguridad y confidencialidad, y que no utilice la
        información del Cliente para propósitos distintos al solicitado por
        BOTON.
      </p>
      <p>
        En ningún caso la utilización de IA por parte de BOTON implicará
        decisiones que afecten al Cliente sin intervención humana en los casos
        en que la legislación requiera dicha intervención. La incorporación de
        la IA tiene como propósito facilitar y agilizar el servicio, pero el
        Cliente siempre podrá contactar a BOTON para aclarar cualquier duda u
        obtener asistencia humana respecto a los resultados generados por estas
        herramientas.
      </p>

      <h4>10. Autorización de acceso con credenciales</h4>
      <p>
        Al proporcionar a BOTON sus credenciales de acceso a sistemas de
        terceros (tales como DGI, Municipio, SIPE, Banco General, entre otros
        mencionados en la sección 6), el Cliente está otorgando expresamente a
        BOTON la autorización para utilizar dichas credenciales en su nombre.
        Esta autorización tiene por único objeto permitir que BOTON inicie
        sesión en los sistemas externos designados y realice las gestiones
        necesarias en representación del Cliente, tales como consultar
        información, descargar documentos (ej. paz y salvo, comprobantes,
        estados de cuenta) o realizar trámites electrónicos permitidos por el
        Cliente (por ejemplo, presentar declaraciones o pagos, siempre que el
        Cliente así lo indique). BOTON utilizará las credenciales únicamente
        para los fines instruidos por el Cliente y en ningún caso llevará a cabo
        acciones en dichos sistemas externos que no estén relacionadas con la
        prestación del servicio acordado.
      </p>
      <p>
        BOTON manejará estas credenciales con el máximo nivel de reserva y
        seguridad, aplicando mecanismos de cifrado y protección equivalentes a
        los descritos en la sección 3, de forma que el personal de BOTON no
        tenga acceso directo a las contraseñas en texto claro (clear text) salvo
        que sea estrictamente necesario para soporte técnico bajo autorización
        del Cliente. El Cliente reconoce que la autorización otorgada es amplia
        pero revocable: podrá eliminar o cambiar sus credenciales de la
        plataforma BOTON en cualquier momento, lo cual retirará la facultad de
        BOTON de seguir accediendo a esos sistemas hasta que se provean
        credenciales válidas nuevamente.
      </p>
      <p>
        Asimismo, se recomienda al Cliente revisar los términos de uso de los
        sistemas externos a los que proporciona acceso, para asegurarse de que
        el uso de sus credenciales por un tercero (BOTON, en este caso) está
        permitido; en caso de restricciones, el Cliente asume la responsabilidad
        por las autorizaciones que conceda.
      </p>

      <h4>11. Aceptación de términos</h4>
      <p>
        El Cliente reconoce que ha aceptado estos Términos y Condiciones de
        manera libre y voluntaria al momento de registrarse en BOTON. La
        plataforma establece un mecanismo de aceptación expresa (como un
        checkbox o casilla de verificación) que el Cliente debe marcar para
        confirmar que está de acuerdo con todas las cláusulas aquí dispuestas,
        incluyendo aquellas relativas al tratamiento de sus datos personales.
        Sin dicha aceptación, no será posible utilizar los servicios de BOTON.
        Se recomienda al Cliente que, antes de manifestar su consentimiento, lea
        detenidamente el presente documento y, en caso de tener dudas, las
        aclare con el equipo de soporte de BOTON.
      </p>
      <p>
        Estos Términos y Condiciones constituyen un acuerdo legalmente
        vinculante entre el Cliente y BOTON desde el momento de su aceptación.
        Si BOTON realizara cambios futuros a estos términos, lo notificará a los
        Clientes por los medios habituales (por ejemplo, vía correo electrónico
        registrado o notificación en la plataforma). El Cliente deberá aceptar
        las nuevas condiciones para continuar utilizando el servicio. En caso de
        no estar de acuerdo con alguna modificación, podrá ejercer su derecho a
        terminar la relación conforme a la sección 13.
      </p>

      <h4>12. Resolución de disputas</h4>
      <p>
        Cualquier controversia o reclamo derivado de la interpretación,
        ejecución, cumplimiento o terminación de estos Términos y Condiciones, o
        relacionado con el uso de la plataforma BOTON, deberá intentarse
        resolver de manera amistosa entre BOTON y el Cliente. En caso de no
        alcanzarse una solución amistosa, las partes acuerdan someter dicha
        controversia a la jurisdicción de los tribunales competentes de la
        República de Panamá, de conformidad con la legislación aplicable vigente
        en Panamá.
      </p>
      <p>
        Este acuerdo se rige por las leyes de la República de Panamá, sin
        perjuicio de los principios de derecho internacional privado que
        pudieran referirse a la aplicación de una ley extranjera. Tanto BOTON
        como el Cliente declaran su entendimiento de que la legislación panameña
        en materia de protección de datos y comercio electrónico será la norma
        rectora de la relación aquí establecida.
      </p>

      <h4>13. Terminación de la relación</h4>
      <p>
        Cualquiera de las partes, ya sea el Cliente o BOTON, podrá dar por
        terminada la relación contractual en cualquier momento. El Cliente podrá
        cancelar su suscripción o cuenta con BOTON solicitándolo a través de la
        plataforma o mediante notificación por escrito a BOTON en cualquier
        momento y sin necesidad de expresar causa. Del mismo modo, BOTON se
        reserva el derecho de suspender o terminar la prestación del servicio al
        Cliente en cualquier momento, ya sea por motivos de incumplimiento de
        estos términos, por consideraciones de seguridad, por cese de
        operaciones de la plataforma, o incluso sin expresar causa (por ejemplo,
        si decide discontinuar el servicio), aunque en este último caso
        procurará notificar al Cliente con una antelación razonable.
      </p>
      <p>
        La terminación de la relación no eximirá al Cliente de cumplir con sus
        obligaciones pendientes, en particular las obligaciones de pago por
        servicios ya prestados o facturados.
      </p>
      <p>
        Una vez finalizada la relación, BOTON restringirá todo acceso del
        Cliente a la plataforma y a sus datos (salvo que, de forma temporal y a
        solicitud del Cliente, se pacte un plazo para exportar la información).
      </p>
      <p>
        Posteriormente, BOTON procederá con la eliminación de los datos del
        Cliente conforme a lo descrito en la sección 15.
      </p>
      <p>
        Ambas partes continuarán obligadas a mantener la confidencialidad sobre
        la información obtenida durante la vigencia de la relación, incluso
        después de terminada ésta, en la medida en que dicha información no sea
        eliminada o pase a ser del dominio público por otras fuentes.
      </p>

      <h4>14. Restricción de acceso por falta de pago</h4>
      <p>
        En caso de que el Cliente incurra en mora o incumplimiento en el pago de
        las tarifas o cuotas pactadas por el uso de la plataforma BOTON, BOTON
        le enviará notificaciones instándole a subsanar el pago pendiente. Si el
        pago no fuese efectuado dentro del plazo indicado en dichas
        notificaciones, BOTON tendrá el derecho de restringir total o
        parcialmente el acceso del Cliente a la plataforma hasta que se
        regularice la situación de pago. Durante el periodo de restricción por
        falta de pago, el Cliente podría no tener acceso a la información y
        funcionalidades del servicio (o tendrá un acceso limitado, por ejemplo
        solo lectura de datos existentes, a discreción de BOTON).
      </p>
      <p>
        Si el Cliente no cumple con sus obligaciones de pago pese a los avisos y
        transcurrido un tiempo razonable, BOTON podrá optar por dar por
        terminada la relación contractual de forma unilateral conforme a la
        sección 13.
      </p>
      <p>
        Esto implicará la cancelación de la cuenta del Cliente y la eliminación
        de sus datos de la plataforma conforme a la sección siguiente.
      </p>
      <p>
        BOTON no tendrá responsabilidad por cualquier daño o pérdida de
        información que resulte de la restricción o terminación del servicio
        debida al incumplimiento de pago por parte del Cliente, por lo que se
        recomienda mantener sus pagos al día para evitar interrupciones en el
        servicio.
      </p>

      <h4>15. Eliminación de datos al cerrar la cuenta</h4>
      <p>
        En caso de cierre de la cuenta o baja del servicio por parte del Cliente
        (ya sea por decisión propia o por terminación efectuada por BOTON),
        todos los datos personales e información asociada al Cliente que se
        encuentren almacenados en la plataforma BOTON serán eliminados de forma
        permanente de nuestros sistemas, a fin de proteger la privacidad del
        Cliente. Una vez que el Cliente solicite la cancelación y se confirme la
        terminación de la relación, BOTON realizará el proceso de supresión de
        datos en un plazo razonable (por ejemplo, dentro de los 30 días
        siguientes), eliminando o anonimizando la información del Cliente de
        todas sus bases de datos activas.
      </p>
      <p>
        Es importante destacar que, una vez completada la eliminación, la
        información no podrá ser recuperada por ningún medio. Por ello, se
        recomienda al Cliente descargar o exportar cualquier dato que pueda
        necesitar con anticipación a la solicitud de cierre de cuenta. BOTON
        podrá conservar de forma segura ciertos datos mínimos durante el tiempo
        que sea requerido para cumplir con obligaciones legales o regulatorias
        posteriores a la terminación (por ejemplo, registros de transacciones o
        facturación necesarios para propósitos fiscales o auditorías), pero
        dichos datos, de existir, quedarán protegidos y bloqueados sin ser
        utilizados para ningún otro fin, y serán eliminados definitivamente una
        vez vencidas las obligaciones de conservación legales. Salvo por lo
        anterior, toda la información del Cliente será depurada de nuestros
        sistemas.
      </p>
      <p>
        Al aceptar estos términos, el Cliente reconoce que entiende y consiente
        que la eliminación de sus datos al cerrar la cuenta es un proceso
        irreversible destinado a salvaguardar su privacidad conforme a la Ley 81
        de 2019.
      </p>
`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Legal
